import React, { useMemo } from 'react'
import { camelCase, capitalize } from 'lodash'

import { useLanguages } from '@/hooks'
import { FleetData } from '@/types'
import { Link } from '@/i18n'

export const FleetCard: React.FC<FleetData> = ({
  EHIWebName,
  LargeImage,
  Transmission,
  ExampleModel,
  LuggageCapacity,
  PassengerCapacity,
  EHIWebVehicleDescription,
}) => {
  const { t } = useLanguages()

  const doorCount = useMemo(
    () => EHIWebVehicleDescription.split(' ')?.[0],
    [EHIWebVehicleDescription],
  )
  return (
    <div className="column small-12 medium-6 large-4 car-item">
      <Link href="#" className="card display-block theme--white blue-color">
        {/* @ts-ignore */}
        <h3>{t(camelCase(EHIWebName))}</h3>
        <p className="description">{ExampleModel}</p>
        <div className="product_list_details flex-container align-center blue-color">
          <div className="flex-container flex-row-wrap text-center align-center align-middle">
            {!!Transmission && (
              <p className="detail_item vehicle--transmission">
                {/* @ts-ignore */}
                {t(`transmission${capitalize(Transmission)}`)}
              </p>
            )}
            {!!PassengerCapacity && (
              <p className="detail_item vehicle--passenger">
                {PassengerCapacity}
              </p>
            )}
            {!!LuggageCapacity && (
              <p className="detail_item vehicle--suitcase">{LuggageCapacity}</p>
            )}
            {!!doorCount && (
              <p className="detail_item vehicle--doors">{doorCount}</p>
            )}
          </div>
        </div>
        <div className="product_list_img text-center">
          <img src={LargeImage} alt="booking countries" title={ExampleModel} />
        </div>
      </Link>
    </div>
  )
}
